import { stopCircleIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const StopO = createIcon({
  displayName: 'StopO',
  paths: [
    'M128 512c0-212.096 171.904-384 384-384s384 171.904 384 384c0 212.096-171.904 384-384 384s-384-171.904-384-384zM810.667 512c0-164.651-133.973-298.667-298.667-298.667s-298.667 134.016-298.667 298.667c0 164.651 133.973 298.667 298.667 298.667s298.667-134.016 298.667-298.667zM362.667 618.667c0 23.595 19.115 42.667 42.667 42.667h213.333c23.552 0 42.667-19.072 42.667-42.667v-213.333c0-23.595-19.115-42.667-42.667-42.667h-213.333c-23.552 0-42.667 19.072-42.667 42.667v213.333z'
  ],
  canvasPaths: canvasIconPaths(stopCircleIcon)
})
